import { Col, Row } from 'react-bootstrap';

const DelinkConfirmationRow = ({label, children}) => (
  <Row>
    <Col md={6}>
      {label}
    </Col>
    <Col md={6}>
      {children}
    </Col>
  </Row>
);

export default DelinkConfirmationRow;
